export enum ConnectorTypeEnum {
  'Type 2' = 'Type 2',
  'Type 1' = 'Type 1',
  'GB/T' = 'GB/T',
  'CCS1' = 'CCS1',
  'CCS2' = 'CCS2',
  'CHAdeMO' = 'CHAdeMO',
  'NACS' = 'NACS',
}
